import { Wrapper } from "./css/SmallSideBarStyle";
import { FaTimes } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import AppLogo from "./AppLogo";
import { toggleSideBar } from "../slices/auth/authenticationSlice";
import NavLinks from "./NavLinks";

const SmallSideBar = () => {
    const { isSideBarOpen } = useSelector((store) => store.auth);
    const dispatch = useDispatch();


    const toggle = () => {
        dispatch(toggleSideBar());
    };

    return (
        <Wrapper>
           <div className={isSideBarOpen ? "sidebar-container show-sidebar" : "sidebar-container"}>
            <div className="content">
                <button className="close-btn" onClick={toggle}>
                    <FaTimes/>
                </button>
                <header>
                    <AppLogo
                        containerStyle="logo-container"
                        textStyle="app-logo-text"
                    />
                </header>
                <NavLinks
                    toggle={toggle}
                />
            </div>
           </div>
        </Wrapper>
    )
};
export default SmallSideBar;